import { Box, CircularProgress } from '@mui/material';

/**
 * Spinner de carregamento inline — substitui o padrão Box+CircularProgress
 * repetido em 18+ arquivos para loading de seções, diálogos e painéis.
 *
 * Diferente do LoadingState (page-level, com texto), este é compacto e
 * usado dentro de cards, dialogs e listas.
 *
 * @param {number|string} [py]        - Padding vertical (default: 3)
 * @param {number|string} [minHeight] - Altura mínima do container
 * @param {number}        [size]      - Tamanho do CircularProgress (default: 24)
 * @param {Object}        [sx]        - sx extra passado ao Box container
 *
 * @example
 * // Loading de seção (dialog, card):
 * {loading && <InlineLoader py={4} />}
 *
 * // Loading com altura mínima (substituindo a view inteira):
 * {loading ? (
 *   <InlineLoader minHeight="300px" size={36} />
 * ) : (
 *   <DataContent />
 * )}
 */
export default function InlineLoader({ py = 3, minHeight, size = 24, sx }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      py={py}
      minHeight={minHeight}
      sx={sx}
    >
      <CircularProgress size={size} />
    </Box>
  );
}
